import { render, staticRenderFns } from "./dash3.vue?vue&type=template&id=4ae4d65a&"
import script from "./dash3.vue?vue&type=script&lang=js&"
export * from "./dash3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports